import { LinearProgress, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { customerColumns } from "./cols";
import { Customer, User } from "../../../models/Customer";
import CustomPagination from "../../atoms/CustomPagination";
import EmptyState from "../../atoms/EmptyState";

interface CustomerDataGridProps {
  data: Customer;
  loading?: boolean;
  onPageChange: (page: number) => void;
  refetch: () => void;
}

const CustomerDataGrid = ({
  data,
  loading,
  onPageChange,
  refetch,
}: CustomerDataGridProps) => {
  return (
    <Stack height={800} justifyContent="left" spacing={2} paddingY={2}>
      <DataGrid
        loading={loading}
        data-testid="customer-table"
        style={{ maxWidth: "100%", overflowX: "scroll" }}
        sx={{
          fontFamily: "Novera,sans-serif",
          fontSize: 14,
          lineHeight: "20px",
          fontWeight: 400,
          "& .MuiDataGrid-footerContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "primary.light",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "mono.white",
          },
          "& .MuiDataGrid-withBorderColor:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            whiteSpace: "unset",
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#E87722",
          },
        }}
        onCellClick={() => {
          console.log("------cllick item------");
        }}
        rows={data?.users || []}
        columns={customerColumns}
        getRowId={(row: User) => row.omneId}
        slots={{
          pagination: CustomPagination,
          loadingOverlay: LinearProgress,
          noRowsOverlay: EmptyState,
        }}
        slotProps={{
          pagination: {
            count: data?.pagination?.totalPages,
            page: (data?.pagination?.currentPage ?? 1) - 1,
            onPageChange: (_, page) => {
              onPageChange(page + 1);
            },
          },
        }}
      />
    </Stack>
  );
};

export default CustomerDataGrid;
